<template>
  <div>
    <Dialog
      :visible.sync="duplicateDialog1"
      :style="{ width: '750px', overflowY: 'auto' }"
      :header="namePlural"
      :modal="true"
      class="p-fluid"
    >
      <!-- The following {{ namePlural }} seems to be a duplicates of the {{ name }} you are trying to save. Please confirm if you wish to still save this {{ name }}? -->

      <div v-for="(element, index) in duplicates" :key="index">
        <h5 style="text-align: center; text-decoration: underline;">
          {{ name }} {{ index + 1 }}
        </h5>
        <div
          class="row"
          :style="key && info ? 'padding: 5px;' : ''"
          v-for="(info, key, index1) in element"
          :key="index1"
        >
          <div class="col col-lg-4 col-md-4" v-if="key && info">
            {{ key }}
          </div>
          <div class="col col-lg-8 col-md-8" v-if="key && info">
            <span v-if="info && info.branchName">{{ info.branchName }}</span>
            <span v-else-if="info && info.custName">{{ info.custName }}</span>
            <span v-else-if="info && info.fullName">{{ info.fullName }}</span>
            <span v-else-if="info && info.projTypeName">{{
              info.projTypeName
            }}</span>
            <span v-else-if="info && info.oppStatusName">{{
              info.oppStatusName
            }}</span>
            <span v-else-if="info && info.salesExecName">{{
              info.salesExecName
            }}</span>
            <span v-else-if="info && info.typeName">{{ info.typeName }}</span>
            <span v-else-if="info && info.regionName">{{
              info.regionName
            }}</span>
            <span v-else>{{ info }}</span>
          </div>
        </div>
        <hr
          style="border: 1px solid black;"
          v-if="index !== duplicates.length - 1"
        />
      </div>

      <template #footer>
        <Button
          @click="$emit('close')"
          label="OK"
          icon="pi pi-check"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    namePlural: {
      type: String,
      required: true
    },
    duplicateDialog: {
      type: Boolean,
      required: true
    },
    duplicates: {
      type: Array,
      required: false
    }
  },
  computed: {
    duplicateDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.duplicateDialog;
      }
    }
  }
};
</script>

<style>
.row:hover {
  background-color: aliceblue;
}
</style>
